exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3HPRHFpUU9mIPv6pciCJ6K{min-width:276px}._3blBPIUcrFfiDnJZPhMolS{width:100%}html[dir] ._3blBPIUcrFfiDnJZPhMolS{margin-top:15px}", ""]);

// exports
exports.locals = {
	"menuFeedback": "_3HPRHFpUU9mIPv6pciCJ6K",
	"sendButton": "_3blBPIUcrFfiDnJZPhMolS"
};